import React from "react";
import { Col, Container, Image, Row, Stack } from "react-bootstrap";
import { FaAnglesRight, FaLocationDot, FaWhatsapp } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { PiFacebookLogo, PiInstagramLogo } from "react-icons/pi";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo/logo_h.png";
import footerBg from "../../assets/images/footerBg.png";

const Footer = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  return (
    <Container fluid className="m-0 p-0">
      <Row className="m-0 py-5">
        <Col lg={6} xs={12}>
          <Image
            src={`${logo}`}
            className="img img-fluid"
            style={{ width: isDesktopOrLaptop ? "50%" : "100%" }}
          />
        </Col>
        <Col lg={3} xs={6}>
          <h5
            className="text-info poppins-semiBold"
            style={{ marginTop: isDesktopOrLaptop ? "0px" : "50px" }}
          >
            Quick Links
          </h5>
          <Stack gap={"3"} className="poppins-regular">
            <Link className="footer-link" to="/">
              <FaAnglesRight className={"txt-green me-2"} size={12} />
              Home
            </Link>
            <Link className="footer-link" to="/accessories">
              <FaAnglesRight className={"txt-green me-2"} size={12} />
              Buy Accessories
            </Link>
            <Link className="footer-link" to="/mobiles">
              <FaAnglesRight className={"txt-green me-2"} size={12} />
              Buy Phone
            </Link>
            <Link className="footer-link" to="/posts">
              <FaAnglesRight className={"txt-green me-2"} size={12} />
              Blog
            </Link>
            {/* <Link className="footer-link" to="/">
              <FaAnglesRight className={"txt-green me-2"} size={12} />
              Terms and Conditions | Policies
            </Link> */}
          </Stack>
        </Col>
        <Col lg={3} xs={6}>
          <h5
            className="text-danger poppins-semiBold mb-4"
            style={{ marginTop: isDesktopOrLaptop ? "0px" : "50px" }}
          >
            Contact Us
          </h5>
          <Stack gap={"3"} className="poppins-regular">
            <Link to={"mailto:info@fixtechexpert.com"} className="footer-link">
              <MdEmail className={"txt-green me-2"} size={16} />
              info@fixtechexperts.co.uk
            </Link>
            <Link
              to={"tel:+447562765555"}
              className="bg-footer-font footer-link"
            >
              <FaWhatsapp className={"txt-green me-2"} size={16} />
              +447562765555
            </Link>
            {/* <Link
              to={"tel:+447551626511"}
              className="bg-footer-font footer-link"
            >
              <PiFacebookLogo className={"txt-green me-2"} size={"1rem"} />
              facebook.com/fixtechexperts
            </Link> */}
            <Link
              to={"tel:+447551626511"}
              className="bg-footer-font footer-link"
            >
              <PiInstagramLogo className={"txt-green me-2"} size={"1rem"} />
              https://www.instagram.com/fixtechexperts/
            </Link>
          </Stack>
        </Col>
      </Row>
      <h6 className="bg-footer-font text-center m-0 py-2 poppins-regular mb-5">
        © FixTechExpert - All rights reserved
      </h6>
    </Container>
  );
};

export default Footer;
